// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-link {\n  background-color: transparent !important;\n  border-color: transparent !important;\n  color: #706967  !important; }\n\n.pagination li {\n  color: #706967  !important;\n  font-size: small; }\n\n.pagination .num {\n  padding-top: 9px; }\n", ""]);
// Exports
module.exports = exports;
